// DeleteUserModal.js
import { Modal, Button, Flex } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import "./DeleteUserModal.scss";
import { ReactComponent as ExclamationIcon } from "../../../assets/Icons/ExclamationIcon.svg";
import NormalButton from "../../../Reuseable/NormalButton/NormalButton";

const DeleteUserModal = ({ open, onClose, onDelete, message, loading = false, userStatus }) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      closable={false}
      // width={224}
      centered
      className="deleteUserModal"
    >
      <div className="deleteModalContent">
        <ExclamationIcon />
        <h3 className="main-content">
          {message || (
            <>
              Are you sure you want
              <br />
              to {userStatus === 'Active' ? 'Disable' : 'Enable'} this user?
            </>
          )}
        </h3>
        <div className="deleteModalActions">
          <Button
            type="default"
            danger
            className="deleteBtn"
            onClick={onDelete}
            loading={loading}
          >
            {userStatus === 'Active' ? 'Disable' : 'Enable'}
          </Button>
          <NormalButton type="default" className="cancelBtn" onClick={onClose}>
            Cancel
          </NormalButton>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteUserModal;
